<style scoped lang="less">
.looking {
	background: #0d6efd;
	margin-left: 10px;

	span {
		font-size: 0.6rem;
		font-weight: 800;
		color: #fff;
	}
}

.smaall {
	background: #0acf97;
	margin-left: 10px;

	span {
		font-size: 0.6rem;
		font-weight: 800;
		color: #fff;
	}
}

.smaall:hover {
	background: #0adf9f;
}

.lookxj {
	background: #ff9528;
	margin-left: 10px;

	span {
		font-size: 0.6rem;
		font-weight: 800;
		color: #fff;
	}
}

.lookxj:hover {
	background: #f38d26;
}

.looking:hover {
	background: #0b67e6;
}

.choiostitle {
	display: flex;
	padding: 0.8rem 0.4rem;
	align-items: center;
	justify-content: space-between;
	background-color: #fff;
	margin-bottom: 1rem;
	border-left: 4px solid #ab26aa;

	.choiosvspde {
		/deep/ .el-button-group {
			width: 9rem;

			button:first-child {
				width: 7rem;
				height: 2rem;
				padding: 0 3px;
			}

			button:last-child {
				width: 1.6rem;
				height: 2rem;
				position: relative;
				padding: 0;
				top: 0px;
				left: 0px;
			}
		}
	}

	.choiostitleleft {
		padding: 0.5rem;
		font-size: 0.8rem;
		border-radius: 50%;
		color: #fff;
		background-color: #ab26aa;
		border: 1px solid;
		text-align: left;
		margin-left: 0.6rem;
		box-sizing: border-box;

		span {
			font-weight: 900;
			font-size: 1.2rem;
		}
	}

	.choiosvdate {
		width: 13rem;
		margin-right: 2%;

		/deep/ .el-input {
			width: 100%;
		}
	}

	.choiosipt {
		// width: 9rem;
		margin-right: 2%;

		/deep/ .el-input {
			width: 100%;
		}
	}

	.choiostitleright {
		display: flex;
		align-items: center;
		justify-content: flex-end;

		div {
			margin: 0 0.2rem;
		}

		.choiosipt {
			/deep/ .el-input--prefix .el-input__inner {
				height: 2rem;
				padding: 1rem 2rem;
			}

			/deep/ .el-input__prefix {
				top: -3px;
			}

			/deep/ .el-input__suffix {
				top: -3px;
			}
		}
	}
}

.orderstable {
	// margin-top: 1rem;
	padding: 1rem;
	width: 100%;
	background-color: #fff;
	border-top: 4px solid #ab26aa;
	border-radius: 2px;

	.oderlookds {
		background-color: #f41127;
	}

	.oderlookd {
		padding: 0.1rem;
		width: 4rem;
		background: rgb(78, 192, 204);
		color: rgb(255, 255, 255);
		margin: 0 auto;
		border-radius: 5px;
	}

	.tabslis {
		/deep/ & ::-webkit-scrollbar {
			width: 5px;
			height: 8px;
			background: linear-gradient(to right, #2e61bf, #60c363);
		}

		& ::-webkit-scrollbar {
			width: 10px;
			height: 5px;
			// background: red;
		}

		& ::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
			border-radius: 0;
			background: rgba(0, 0, 0, 0.1);
		}

		/deep/ .el-table {
			th,
			td {
				text-align: center;
			}

			td {
				button {
					color: #fff;
					border-radius: 5px;
					margin: 5px;
				}

				.looking {
					background: #0d6efd;
					// margin-left: 10px;

					span {
						font-size: 0.6rem;
						font-weight: 800;
					}
				}

				.looking:hover {
					background: #0b67e6;
				}

				.giveempower {
					background: #ff8300;

					span {
						font-size: 0.6rem;
					}
				}

				.giveempower:hover {
					background: #e17000;
				}

				.edit {
					background: #17a001;

					span {
						font-size: 0.6rem;
					}
				}

				.edit:hover {
					background: #1fcf00;
				}

				.delete {
					background: #ec0f25;

					span {
						font-size: 0.6rem;
					}
				}

				.delete:hover {
					background: #ff1128;
				}
			}
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}

		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background: linear-gradient(to right, #018761, #39b170);
			// color: #FFF;
		}
	}

	.schooltitle {
		font-size: 1.2rem;
		color: #ab26aa;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ccc;
		padding-bottom: 1rem;
		position: relative;

		button {
			padding: 0.4rem;
			background: #fe8930;
			font-size: 0.6rem;
			border-radius: 3px;
			padding: 0.6rem 1.2rem;
			position: absolute;
			right: 1%;
			color: #fff;

			span {
				color: #fff;
				margin-right: 0.2rem;
				font-weight: 900;
			}
		}

		span.el-icon-s-management {
			display: block;
			padding: 0.4rem;
			border-radius: 50%;
			font-size: 1rem;
			margin-right: 0.4rem;
			box-sizing: border-box;
			background: #ab26aa;
			color: #fff;
		}
	}
}

.paginations {
	height: 3rem;
	line-height: 3rem;

	input {
		width: 3rem;
		height: 1.8rem;
		padding: 0 0 0 0.8rem;
		border: 1px solid #ccc;
	}
}

#sector {
	min-height: 90%;
}

.lookxqs {
	width: 100%;
	box-sizing: border-box;
	background: linear-gradient(to right, #0898ff, #0898ff);
	color: #fff;
	padding: 0 1rem;
	border-radius: 10px;
	margin-bottom: 1rem;

	.lookxqbottom {
		padding-left: 1rem;

		ul {
			width: 50% !important;
			li:first-child {
				font-size: 0.8rem !important;
				font-weight: 600;
			}
			li {
				width: 40% !important;
			}

			margin-right: 6rem;
		}
	}

	.lookxqtop,
	.lookxqbottom {
		padding: 0.6rem 0;
		display: flex;
		box-sizing: border-box;
		align-items: center;
		flex-wrap: wrap;
		justify-items: flex-start;
		border-bottom: 1px solid #83cbff;

		ul {
			margin: 0.2rem 0;
			width: 100%;

			li:last-child {
				span {
					display: none;
				}
			}

			box-sizing: border-box;
			align-items: center;

			li {
				font-size: 0.8rem;
				width: 30%;
				text-align: center;
				display: inline-block;
			}

			li:first-child {
				font-size: 1rem;
				font-weight: 600;
				margin-right: 1rem;
				width: 15%;
			}

			// margin-right: 6rem;
		}
	}
}

.lookxqtop,
.lookxqbottom {
	ul::-webkit-scrollbar  {
		width: 2px;
		// height: 10px; // 高度写不写，都不影响，因为会根据内容的长度自动计算
	}

	ul::-webkit-scrollbar-thumb {
		background: #ccc; // 滑块颜色
		border-radius: 5px; // 滑块圆角
	}
	div::-webkit-scrollbar  {
		display: none;
	}
	div::-webkit-scrollbar-thumb {
		display: flex;
	}
}

.scllocw {
	overflow-y: scroll;
}

.ablictyly {
	height: 53vh;
	border: 1px solid transparent;
	border-radius: 10px;
	background-color: #fff;

	padding-bottom: 1rem;
	position: relative;

	.abilitysgn {
		height: 90%;
		// 左右对称：原只有 padding-left，雷达图容器被整体推右，
		// 与右侧「实训项目统计」卡片（无内边距）并排时偏移明显
		padding: 0 1rem;
	}

	.ablictylybottom {
		padding: 0 1rem;
		height: 76%;

		/deep/ .el-table__header {
			th {
				text-align: center;
			}
		}

		/deep/ .el-table__row {
			td {
				text-align: center;
			}
		}
	}

	.totles {
		position: absolute;
		bottom: 0;
		left: 0;
		background-color: #fff;
		box-sizing: border-box;
		box-shadow: 10px 10px 10px 10px rgba(0, 0, 0, 0.1);
		padding: 10px 0;
	}

	.ablictylycenter {
		width: 100%;
		display: flex;
		align-items: center;
		justify-items: flex-start;
		padding: 0.4rem 0.4rem;
		height: 3rem;
		line-height: 3rem;

		.actives {
			border: 1px solid;
			height: 2rem;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 1rem;
			border-radius: 10rem;
			color: #fff;
			background: #4a8dc9;
		}

		p {
			cursor: pointer;
			margin-right: 1rem;
			color: #333;
			font-size: 0.8rem;
		}

		/deep/ .el-select {
			width: 70%;
		}

		/deep/ .el-input__inner {
			height: 30px;
		}

		/deep/ .el-input__icon {
			line-height: 30px;
		}

		/deep/ .el-button {
			padding: 8px 20px;
			margin-left: 1rem;
			color: #fff;
			background-color: #2ebf91;
			font-size: 1rem;
		}
	}

	.ablictylytop {
		display: flex;
		align-items: center;
		justify-items: flex-start;
		background-color: #ffa319;
		color: #fff;
		padding: 0.2rem 0.6rem;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;

		img {
			border: 1px solid;
			padding: 0.2rem;
			border-radius: 0.4rem;
			background-color: rgba(255, 255, 255, 0.4);
		}

		p {
			margin-left: 0.4rem;
			font-size: 1rem;
			font-weight: 600;
			letter-spacing: 1px;
		}
	}

	&::-webkit-scrollbar-thumb {
		width: 5px;
		background: #ccc; // 滑块颜色
		border-radius: 5px; // 滑块圆角
	}
}

.totles {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 1rem;
	font-size: 1rem;
	color: #333;

	p {
		margin-right: 1rem;
	}
}

.backtavle {
	width: 4rem;
	height: 4rem;
	border-radius: 50%;
	border: 1px solid;
	background: #0a4a87;
	position: fixed;
	bottom: 6%;
	text-align: center;
	line-height: 4rem;
	right: 1%;
	cursor: pointer;
	z-index: 999;
}

/deep/ .tablestitle {
	color: #333;

	.cell {
		font-weight: 600 !important;
	}

	// font-size: 1rem;
}
</style>
<template>
	<div>
		<titles titlename="实训详情" titlecontent="这里可以看到我的实训详情信息"></titles>

		<div class="lookxq">
			<div class="lookxqs">
				<div class="lookxqtop">
					<div class="backtavle" @click="backtavle()">返回表格</div>
					<ul>
						<li>课程/任务名称</li>
						<li style="width: auto;">{{ objectName }}</li>
					</ul>
					<div style="width: 100%;overflow-x: scroll;">
						<ul style="white-space:nowrap">
							<li>实训项目名称</li>
							<li v-for="(item, index) in abilitysgnlist">
								{{ item.TDT_ProjectName }}
								<span>&nbsp; ~ &nbsp;</span>
							</li>
						</ul>
					</div>
				</div>

				<div class="lookxqbottom" style="display: flex;align-items: center;flex-wrap: wrap;">
					<ul>
						<li>用户名</li>
						<li>{{ abilitysgnobj1.userName }}</li>
					</ul>
					<ul>
						<li>所属班级</li>
						<li>{{ abilitysgnobj1.cla_name }}</li>
					</ul>
					<ul>
						<li>实训成绩</li>
						<li>{{ totles }}</li>
					</ul>

					<ul>
						<li>实训开始时间</li>
						<li>{{ abilitysgnobj1.TDT_StartTime }}</li>
					</ul>
					<ul>
						<li>实训结束时间</li>
						<li>{{ abilitysgnobj1.TDT_EndTime }}</li>
					</ul>
					<ul>
						<li>实训操作类型</li>
						<li>{{ abilitysgnobj1.TDT_TaskType == '2' ? '多用户实训' : '单用户实训' }}</li>
					</ul>
				</div>
			</div>
			<el-row :gutter="20">
				<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
					<div class="ablictyly" style="margin-bottom: 1rem;">
						<div class="ablictylytop">
							<img src="../../assets/allcss/books.svg" alt="" />
							<p>综合能力评估</p>
						</div>
						<div class="abilitysgn">
							<div id="sector"></div>
							<div class="abilitybottom">
								<p style="display: flex;align-items: center;">
									星级指数：
									<span><el-rate v-model="scores" disabled :max="10" allow-half text-color="#ff9900"></el-rate></span>
								</p>
								<p>
									智能点评：
									<i style="color: red; text-decoration: underline;">{{ notes }}</i>
								</p>
							</div>
						</div>
					</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
					<div class="ablictyly">
						<div class="ablictylytop" style="background-color: #5569FF;">
							<img src="../../assets/allcss/syblone.svg" alt="" />
							<p>实训项目统计</p>
						</div>
						<div class="ablictylycenter">
							<p>选择实训项目：</p>
							<p class="ablictylyp" @click="lookchange(index)" :class="{ actives: xqvalue == index }" v-for="(item, index) in xqoptions" :key="index">
								{{ item.value }}
							</p>
						</div>
						<div class="ablictylybottom scllocw">
							<el-table :data="GtsxTrainingList" style="width: 100%">
								<el-table-column type="index" label="序号" :index="indexMethod"></el-table-column>
								<el-table-column prop="TDI_Content" title="TDI_Content" label="操作名称" width="180"></el-table-column>
								<el-table-column prop="TDI_Score" label="得分" width="180"></el-table-column>
								<el-table-column prop="tsScore" label="扣分">
									<template slot-scope="scope">
										<p>{{ scope.row.TDI_TotalScore - scope.row.TDI_Score }}</p>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="totles">
							<p>
								<span>总计得分：</span>
								<span>{{ totles }}</span>
							</p>
							<p>
								<span>总计扣分：</span>
								<span style="color: red;">{{ totsles }}</span>
							</p>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import {
	GetMyTrainDataList,
	getTraiDetailByTOPIDList,
	getTrainSTAByGUID,
	GetMyTrainDataListApi,
	getTraiDetailByTOPIDListApi,
	getTrainSTAByGUIDApi
} from '@/request/api/userapi/studenthome.js';
import { GetMyComprehensiveSTAApi } from '@/request/api/homesview/yunhomes/yunhom';
import AppOptions from '@/config/AppOptions.vue';
export default {
	components: {},
	data() {
		return {
			TrainingRooms: {},
			// 详情扣分项
			xqoptions: [],
			xqvalue: 0,
			// 查看详情
			looingz: 0,
			tackname: '',
			// 弹窗
			tabsnun: 10,
			Optiondata2: [],
			// 搜索
			search: '',
			// 时间选择
			vdate: '',
			venddate: '',
			// 标题
			paths: [
				{
					path: '/usercenter/myrealtestchart',
					name: '实训详情'
				}
			],
			tableData: [],
			allnum: 10,
			pageindex: 1,
			abilitysgnlist: [],
			objectName: '',
			abilitysgnobj1: {},
			abilitysgnobj2: {},
			// 分数
			abilityjgalist: [],
			GtsxTrainingList: [],
			// 总计
			totles: 0,
			totsles: 0,
			// 实训能力评估
			scores: 0,
			notes: '',
			chart1: {},
			abilitysgnobjs: {},
			// 无数据时的占位轴：indicator 为空数组时 ECharts 不会渲染任何图形，
			// 故用一组空名轴撑出雷达网格，保证「没数据也有图形」
			emptyIndicator: [
				{ name: '', max: 100 },
				{ name: '', max: 100 },
				{ name: '', max: 100 },
				{ name: '', max: 100 },
				{ name: '', max: 100 },
				{ name: '', max: 100 }
			],
			option: {
				tooltip: {
					trigger: 'item'
				},
				radar: {
					radius: '65%',
					// 图表居中：水平 50%，垂直 50%
					center: ['50%', '50%'],
					startAngle: 90,
					splitNumber: 5,
					nameGap: 20,
					name: {
						textStyle: {
							fontSize: 11,
							color: '#333',
							lineHeight: 15
						},
						// 截断/换行处理，避免长标签重叠
						formatter: function(value) {
							if (!value) return '';
							const maxLen = 8;
							const maxLines = 2;
							let lines = [];
							let rest = value;
							while (rest.length > 0 && lines.length < maxLines) {
								lines.push(rest.slice(0, maxLen));
								rest = rest.slice(maxLen);
							}
							let result = lines.join('\n');
							if (rest.length > 0) {
								result += '…';
							}
							return result;
						}
					},
					splitArea: {
						show: true,
						areaStyle: {
							color: [
								'rgba(157,200,241,0.1)',
								'rgba(157,200,241,0.3)',
								'rgba(157,200,241,0.1)',
								'rgba(157,200,241,0.3)',
								'rgba(157,200,241,0.1)'
							]
						}
					},
					splitLine: {
						lineStyle: {
							color: '#cfd8dc'
						}
					},
					axisLine: {
						lineStyle: {
							width: 1,
							color: '#cfd8dc'
						}
					},
					indicator: []
				},
				series: [{
					type: 'radar',
					symbol: 'circle',
					symbolSize: 6,
					itemStyle: {
						color: '#5fa6e6'
					},
					lineStyle: {
						color: '#9DC8F1',
						width: 2
					},
					areaStyle: {
						color: '#9DC8F1',
						opacity: 0.55
					},
					emphasis: {
						areaStyle: {
							opacity: 0.75
						},
						itemStyle: {
							color: '#1f7fd1'
						}
					},
					data: [
						{
							value: [],
							name: '熟练程度'
						}
					]
				}]
			},
			chartsoption: {
				xAxis: {
					type: 'category',
					data: [],
					axisLabel: {
						show: true,
						textStyle: {
							color: 'blue'
						}
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: 'blue'
						}
					},
					axisPointer: {
						show: true,
						link: {
							xAxisIndex: 0,
							yAxisIndex: 0,
							symbol: ['none', 'circle'],
							symbolSize: [3, 10],
							lineStyle: {
								width: 2,
								color: 'blue'
							}
						},
						label: {
							show: true,
							position: 'nearest',
							formatter: '{value}'
						}
					}
				},
				yAxis: {
					type: 'value',
					axisLabel: {
						show: true,
						textStyle: {
							color: 'blue'
						}
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: 'blue'
						}
					},
					axisPointer: {
						show: false,
						link: {
							xAxisIndex: 0,
							yAxisIndex: 0,
							symbol: ['none', 'circle'],
							symbolSize: [3, 10],
							lineStyle: {
								width: 2,
								color: 'blue'
							}
						},
						label: {
							show: true,
							position: 'nearest',
							formatter: '{value}'
						}
					}
				},
				tooltip: {
					trigger: 'item',
					
					formatter: function(params) {
						return '<div style="background-color: black; color: white; padding: 5px;">' + 'Series: ' + params[0].name + '<br></div>';
					}
				},
				series: [
					{
						name: '实训项目分数分布图',
						type: 'line',
						data: []
					}
				]
			}
		};
	},
	mounted() {
		this.tackname = this.$route.query.id;

		this.chars();
		this.getxqtop();
	},
	components: {
		titles
	},
	computed: {
		tabsnum() {
			return Number(this.tabsnun);
		}
	},
	created() {
		AppOptions.appEmpty = false;
	},
	updated() {},
	methods: {
		changetrvd() {
			let date = new Date(this.vdate);
			let y = date.getFullYear();
			let m = date.getMonth() + 1;
			m = m < 10 ? '0' + m : m;
			let d = date.getDate();
			d = d < 10 ? '0' + d : d;
			const time = y + '-' + m + '-' + d;
			// console.log(time);
			var traisnobjs = {
				index: this.pageindex,
				size: this.tabsnun,
				ui_guid: localStorage.getItem('uiguid'),
				taskName: '',
				startTime: time,
				endTime: '',
				TDT_ProjectName: ''
			};
			this.gettrindapi(traisnobjs);
		},
		changetrvds() {
			var date = new Date(this.venddate);
			var y = date.getFullYear();
			var m = date.getMonth() + 1;
			m = m < 10 ? '0' + m : m;
			var d = date.getDate();
			d = d < 10 ? '0' + d : d;
			var times = y + '-' + m + '-' + d;
			var traisnobjs = {
				index: this.pageindex,
				size: this.tabsnun,
				ui_guid: localStorage.getItem('uiguid'),
				taskName: '',
				startTime: '',
				endTime: times,
				TDT_ProjectName: ''
			};

			this.gettrindapi(traisnobjs);
		},

		backtavle() {
			this.$router.go(-1);
		},

		lookchange(i) {
			console.log(i);
			this.xqvalue = i;
			this.getxqtop(i);
		},

		lookingstain() {
			console.log(this.xqvalue);
		},

		// 变化选框切换
		changgetainl(i) {
			console.log(i);
			this.getxqtop(i);
		},

		indexMethod(index) {
			return (index += 1);
		},

		// 搜索更改列表
		changetrainlist() {
			// console.log("搜索")
			var reg = /^[\da-z]+$/i;
			let searchse = '';
			let searchseas = '';
			reg.test(this.search) == true ? (searchse = this.search) : (searchseas = this.search);
			var traisnobj = {
				index: this.pageindex,
				size: this.tabsnun,
				ui_guid: localStorage.getItem('uiguid'),
				taskName: searchse,
				startTime: '',
				endTime: '',
				TDT_ProjectName: searchseas
			};
			this.gettrindapi(traisnobj);
		},

		// 确保 chart 实例存在（接口异常时也要能画出图形）
		initChart() {
			if (this.chart1 && this.chart1.setOption) return this.chart1;
			let el = document.getElementById('sector');
			if (!el) return null;
			this.chart1 = this.$echarts.init(el);
			return this.chart1;
		},

		// 无数据 / 接口异常：画出空雷达网格 + 中心提示，不留白
		renderEmptyRadar(tip) {
			let chart = this.initChart();
			if (!chart) return;
			this.option.graphic = [
				{
					type: 'text',
					left: 'center',
					top: 'center',
					z: 10,
					style: {
						text: tip || '暂无评估数据',
						fill: '#9aa5b1',
						fontSize: 14
					}
				}
			];
			this.option.radar.indicator = this.emptyIndicator;
			this.option.series[0].data[0].value = this.emptyIndicator.map(() => 0);
			chart.setOption(this.option, true);
		},

		// 有数据：按能力维度正常渲染
		renderRadar(projelist, totalscore) {
			let chart = this.initChart();
			if (!chart) return;
			this.option.graphic = null;
			this.option.series[0].data[0].value = totalscore;
			this.option.radar.indicator = projelist;
			chart.setOption(this.option, true);
		},

		// 把后端能力维度数据转成雷达图。
		// 兼容两套接口的字段名与两种分制：
		//   名称：GetMyComprehensiveSTA 用 projectName，GetTrainSTAByGUID 用 TDI_Content
		//   分值：resultScore 已是百分制；否则用 projecScore / totalScore 折算成百分制
		//         （直接用 projecScore 会因 max=100 把图形压到几乎不可见）
		applyAbility(list, notes, score) {
			let projelist = [];
			let totalscore = [];
			(list || []).forEach(item => {
				let name = item.projectName || item.TDI_Content || '';
				let val = 0;
				if (item.resultScore !== undefined && item.resultScore !== null) {
					val = Number(item.resultScore) || 0;
				} else {
					let full = Number(item.totalScore) || 0;
					let got = Number(item.projecScore) || 0;
					val = full > 0 ? (got / full) * 100 : 0;
				}
				projelist.push({ name: name, max: 100 });
				totalscore.push(Math.round(val * 10) / 10);
			});

			if (projelist.length > 0) {
				this.renderRadar(projelist, totalscore);
			} else {
				this.renderEmptyRadar('暂无评估维度');
			}

			if (notes !== undefined && notes !== null) {
				this.notes = notes;
			}
			if (score !== undefined && score !== null) {
				this.scores = Math.floor((Number(score) || 0) * 2) / 2;
			}
		},

		chars() {
			// 先落一个空图形，避免请求期间白屏
			this.renderEmptyRadar('数据加载中…');

			getTrainSTAByGUIDApi(this.tackname)
				.then(res => {
					let data1 = res && res.data && res.data.data;
					if (!data1) {
						this.renderEmptyRadar('暂无评估数据');
						return;
					}

					// 线上环境：该接口本身就返回能力维度明细（实测 11 条），
					// 而 sx_te_guid 为 null。若仍以 sx_te_guid 为唯一入口，
					// 会导致有数据却永远走不到渲染分支。故优先用它自带的 list。
					let abilityList = data1.list || [];
					if (abilityList.length > 0) {
						this.applyAbility(abilityList, data1.notes, data1.score);
						return;
					}

					let sx_te_guid = data1.sx_te_guid || '';
					if (!sx_te_guid) {
						// 该实训暂无能力评估记录：保留空雷达图形
						this.renderEmptyRadar('暂无评估数据');
						this.notes = data1.notes || '';
						this.scores = Math.floor((Number(data1.score) || 0) * 2) / 2;
						return;
					}

					// 回退：sx_te_guid 有效时走专项接口
					GetMyComprehensiveSTAApi({ sx_te_guid: sx_te_guid })
						.then(res2 => {
							let data2 = res2 && res2.data && res2.data.data;
							let list2 = (data2 && data2.list) || [];
							this.applyAbility(list2, data2 && data2.notes, data2 && data2.score);
						})
						.catch(err => {
							console.error('综合能力评估接口失败', err);
							this.renderEmptyRadar('评估数据加载失败');
						});
				})
				.catch(err => {
					console.error('实训分析接口失败', err);
					this.renderEmptyRadar('数据加载失败');
				});

			window.onresize = () => {
				if (this.chart1 && this.chart1.resize) {
					this.chart1.resize();
				}
			};
		},
		handleClose(done) {
			done();
			// this.$confirm('确认关闭？')
			// 	.then(_ => {
			// 		done();
			// 	})
			// 	.catch(_ => {});
		},
		// 查看详情
		tableTraiDetail(e, id) {
			this.looingz = 1;
			this.tackname = id;
			this.chars();
			this.getxqtop();
		},
		// 查看详情
		// 清空详情区（无数据 / 接口异常时调用，避免模板取 [0] 抛错）
		resetDetail() {
			this.abilitysgnlist = [];
			this.abilityjgalist = [];
			this.objectName = '';
			this.abilitysgnobj1 = {};
			this.GtsxTrainingList = [];
			this.xqoptions = [];
			this.totles = 0;
			this.totsles = 0;
		},

		getxqtop(i = 0) {
			getTraiDetailByTOPIDListApi(this.tackname).then(res => {
				// console.log(res, "查看详情")
				// 后端无数据时返回 data:[]，此处必须判空：
				// 直接 res.data.data[0].TDT_TaskName 会抛 TypeError，空数组 reduce 无初值也会抛
				let list = (res && res.data && res.data.data) || [];
				if (list.length === 0) {
					this.resetDetail();
					return;
				}

				this.abilitysgnlist = list.length > 4 ? list.slice(0, 4) : list;
				this.objectName = list[0].TDT_TaskName;
				this.abilitysgnobj1 = list[0];
				if (list[0]) {
					this.GtsxTrainingList = list[0].GtsxTrainingList;
				}
				// this.abilitysgnobj2 = list[0].TrainingEquipment;
				this.abilityjgalist = this.abilitysgnlist;
				let xqoptionslist = [];
				this.abilitysgnlist.forEach((item, index) => {
					let abiltyobj = {};
					abiltyobj.value = item.TDT_ProjectName;
					abiltyobj.lable = index;
					xqoptionslist.push(abiltyobj);
				});
				this.xqoptions = xqoptionslist;

				let totlelist = [];
				let totleslist = [];
				this.abilityjgalist.forEach((item, index) => {
					// console.log(item.projecScore,item.totalgrade)
					let tsscov = parseInt(item.TDT_TotalScore) - parseInt(item.TDT_Score);
					totleslist.push(tsscov);
					item.tsScore = tsscov;
					totlelist.push(item.TDT_Score);
				});
				// console.log(totleslist,totlelist)

				// 传初值 0：空数组时 reduce 无初值会抛错
				this.totles = totlelist.reduce(function(pre, curr) {
					return pre + curr;
				}, 0);

				this.totsles = totleslist.reduce(function(pre, curr) {
					return pre + curr;
				}, 0);
			}).catch(err => {
				console.error('实训详情接口失败', err);
				this.resetDetail();
			});
		},

		// 改变表格
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.pageindex = val;
			this.gettrindapi();
		},

		// 改变表单
		changenumber() {
			this.gettrindapi();
		},
		gettrindapi(trnobj = null) {
			let trainobj = {
				index: this.pageindex,
				size: this.tabsnun,
				ui_guid: localStorage.getItem('uiguid'),
				taskName: '',
				startTime: '',
				endTime: '',
				projectName: ''
			};

			trainobj = trnobj == null ? trainobj : trnobj;
			GetMyTrainDataListApi(trainobj).then(res => {
				console.log(res.data.data, '我的实训记录');
				this.allnum = res.data.data.totalCount;
				this.tableData = res.data.data.list;
				this.tableData.forEach(item => {
					if (item.as_isArrival == false) {
						item.as_isArrival = '否';
					} else {
						item.as_isArrival = '是';
					}
				});
			});
		}
	}
};
</script>
